import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getModule } from './module';
export const ReduxInitLoadable = ()=>/*#__PURE__*/ React.createElement(DynamicModuleLoader, {
        modules: [
            getModule()
        ]
    });
ReduxInitLoadable.displayName = 'TierConsumerReduxLoadable';
export default ReduxInitLoadable;
